@if (authService.account()) {
<div class="flex flex-col h-screen overflow-hidden">
  <nav class="bg-surface dark:bg-surface-dim font-body-md text-body-md border-b border-border-subtle dark:border-outline-variant flex justify-between items-center w-full px-margin-desktop h-16 z-50 relative shrink-0">
    <div class="flex items-center gap-xl">
      <button (click)="toggleMobileMenu()" title="Menu"
              class="md:hidden -ml-2 p-2 rounded-lg text-text-muted dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">
        <span class="material-symbols-outlined">menu</span>
      </button>
      <img src="traxtion-logo.jpg" alt="TraXtion" class="h-8 w-auto shrink-0" />
      <div class="hidden md:flex items-center gap-lg">
        @if (authService.canSeeOperations()) {
        <div class="relative">
          <button (click)="toggleOperationsMenu()"
                  class="flex items-center gap-1 transition-colors cursor-pointer active:opacity-80"
                  [ngClass]="isOperationsRoute() ? 'text-[#00B9F2]' : 'text-text-muted dark:text-on-surface-variant'">
            Operations
            <span class="material-symbols-outlined text-[18px]" [class.rotate-180]="operationsMenuOpen()">expand_more</span>
          </button>
          @if (operationsMenuOpen()) {
            <div class="absolute top-full left-0 mt-2 w-48 bg-surface dark:bg-surface-container border border-border-subtle dark:border-outline-variant rounded-lg shadow-lg py-2 z-50">
              <a routerLink="/dashboard" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Dashboard</a>
              <a routerLink="/dealers" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Dealers</a>
              <a routerLink="/dealer-map" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Dealer Map</a>
              <a routerLink="/jobs" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Jobs &amp; Dispatch</a>
              <a routerLink="/vehicles" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Vehicle Management</a>
              <a routerLink="/scheduling" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Scheduling</a>
              <a routerLink="/inventory" (click)="closeOperationsMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Inventory</a>
            </div>
          }
        </div>
        }

        @if (authService.canSeeTechnicians()) {
        <div class="relative">
          <button (click)="toggleTechniciansMenu()"
                  class="flex items-center gap-1 transition-colors cursor-pointer active:opacity-80"
                  [ngClass]="isTechniciansRoute() ? 'text-[#00B9F2]' : 'text-text-muted dark:text-on-surface-variant'">
            Technicians
            <span class="material-symbols-outlined text-[18px]" [class.rotate-180]="techniciansMenuOpen()">expand_more</span>
          </button>
          @if (techniciansMenuOpen()) {
            <div class="absolute top-full left-0 mt-2 w-48 bg-surface dark:bg-surface-container border border-border-subtle dark:border-outline-variant rounded-lg shadow-lg py-2 z-50">
              <a routerLink="/my-jobs" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">My Jobs</a>
              <a routerLink="/clock-in-out" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Clock In / Out</a>
              <a routerLink="/technician-inventory" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Inventory</a>
              <a routerLink="/technician-performance" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Performance</a>
              <a routerLink="/nearby-dealers" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Nearby Dealers</a>
              @if (authService.isAdmin()) {
                <a routerLink="/technicians" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                   class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Technicians</a>
              }
              <a routerLink="/notifications" (click)="closeTechniciansMenu()" routerLinkActive="text-[#00B9F2] bg-surface-variant/50"
                 class="block px-4 py-2 text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors">Notifications</a>
            </div>
          }
        </div>
        }

        @if (authService.isCsmOnly()) {
          <a routerLink="/scheduling" routerLinkActive="text-[#00B9F2]"
             class="text-text-muted dark:text-on-surface-variant transition-colors cursor-pointer">Scheduling</a>
          <a routerLink="/dealer-map" routerLinkActive="text-[#00B9F2]"
             class="text-text-muted dark:text-on-surface-variant transition-colors cursor-pointer">Dealer Map</a>
        }
      </div>
    </div>

    @if (authService.account(); as acc) {
      <div class="hidden md:flex items-center gap-3">
        <div class="text-right">
          <p class="font-label-sm text-text-main dark:text-on-surface leading-tight">{{ acc.name || acc.username }}</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs leading-tight">{{ authService.roles().join(', ') || 'No role assigned' }}</p>
        </div>
        <button (click)="logout()" title="Log out"
                class="w-9 h-9 rounded-full border border-border-subtle dark:border-outline-variant hover:bg-surface-variant dark:hover:bg-surface-variant flex items-center justify-center text-text-muted dark:text-on-surface-variant transition-colors">
          <span class="material-symbols-outlined text-[20px]">logout</span>
        </button>
      </div>
    }
  </nav>

  <div class="flex flex-1 overflow-hidden">
    @if (mobileMenuOpen()) {
      <div class="fixed inset-0 bg-black/40 z-[55] md:hidden" (click)="closeMobileMenu()"></div>
    }

    <aside
      class="bg-surface dark:bg-surface-container-low font-label-md text-label-md flex flex-col py-lg space-y-base w-[280px] border-r border-border-subtle dark:border-outline-variant shrink-0 overflow-y-auto
             fixed inset-y-0 left-0 z-[60] transform transition-transform duration-200 ease-in-out
             md:static md:transform-none md:z-40"
      [ngClass]="mobileMenuOpen() ? 'translate-x-0' : '-translate-x-full'">
      <div class="px-6 pb-6 border-b border-border-subtle dark:border-outline-variant mb-4 flex items-center gap-4">
        <div class="w-10 h-10 rounded-full bg-surface-variant dark:bg-surface-container-highest flex items-center justify-center border border-border-subtle dark:border-outline-variant overflow-hidden shrink-0 text-text-muted">
          <span class="material-symbols-outlined text-[20px]">business</span>
        </div>
        <div class="flex-1">
          <h2 class="font-headline-md text-headline-md text-[#00B9F2] text-lg leading-tight">Field Service</h2>
          <p class="text-text-muted dark:text-on-surface-variant font-label-sm text-label-sm">{{ authService.roles().join(', ') || 'Management Console' }}</p>
        </div>
        <button (click)="closeMobileMenu()" title="Close menu"
                class="md:hidden p-1 rounded-full hover:bg-surface-variant dark:hover:bg-surface-variant text-text-muted dark:text-on-surface-variant">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <nav class="px-2 mb-2">
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/home" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">home</span>
          Home
        </a>
      </nav>

      @if (authService.canSeeOperations()) {
      <div class="px-4 mb-6">
        <a routerLink="/jobs" class="w-full bg-[#00B9F2] text-white font-label-md text-label-md py-3 px-4 rounded-lg flex items-center justify-center gap-2 hover:opacity-90 transition-opacity h-[48px]">
          <span class="material-symbols-outlined text-[20px]">add</span>
          New Dispatch
        </a>
      </div>
      }

      <nav class="flex-1 flex flex-col gap-2">
        @if (authService.canSeeOperations()) {
        <p class="px-6 mb-1 mt-4 text-text-muted dark:text-on-surface-variant font-label-sm text-xs uppercase tracking-wide">Operations</p>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/dashboard" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">dashboard</span>
          Dashboard
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/dealers" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">store</span>
          Dealers
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/dealer-map" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">map</span>
          Dealer Map
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/jobs" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">assignment</span>
          Jobs &amp; Dispatch
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/scheduling" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">calendar_month</span>
          Scheduling
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/inventory" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">inventory_2</span>
          Inventory
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/vehicles" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">local_shipping</span>
          Vehicle Management
        </a>
        }

        @if (authService.canSeeTechnicians()) {
        <p class="px-6 mb-1 mt-4 text-text-muted dark:text-on-surface-variant font-label-sm text-xs uppercase tracking-wide">Technicians</p>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/my-jobs" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">checklist</span>
          My Jobs
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/clock-in-out" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">schedule</span>
          Clock In / Out
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/technician-inventory" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">inventory_2</span>
          Inventory
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/technician-performance" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">insights</span>
          Performance
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/nearby-dealers" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">near_me</span>
          Nearby Dealers
        </a>
        @if (authService.isAdmin()) {
          <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
             routerLink="/technicians" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
            <span class="material-symbols-outlined">engineering</span>
            Technicians
          </a>
        }
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/notifications" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">notifications</span>
          Notifications
        </a>
        }

        @if (authService.isCsmOnly()) {
        <p class="px-6 mb-1 text-text-muted dark:text-on-surface-variant font-label-sm text-xs uppercase tracking-wide">My Access</p>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/scheduling" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">calendar_month</span>
          Scheduling
        </a>
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg mx-2 px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out"
           routerLink="/dealer-map" routerLinkActive="bg-surface-variant dark:bg-surface-variant">
          <span class="material-symbols-outlined">map</span>
          Dealer Map
        </a>
        }
      </nav>

      <div class="mt-auto border-t border-border-subtle dark:border-outline-variant pt-4 px-2 flex flex-col gap-2">
        <a class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out" href="#">
          <span class="material-symbols-outlined">help</span>
          Support
        </a>
        <button (click)="logout()"
                class="text-text-main dark:text-on-surface-variant hover:bg-surface-variant dark:hover:bg-surface-variant rounded-lg px-4 py-3 flex items-center gap-3 transition-all duration-200 ease-in-out text-left">
          <span class="material-symbols-outlined">logout</span>
          Log Out
        </button>
      </div>
    </aside>

    <main class="flex-1 overflow-y-auto p-margin-mobile md:p-margin-desktop relative">
      <router-outlet />
    </main>
  </div>
</div>
} @else {
  <router-outlet />
}
